export default "__VITE_ASSET__B$hI07Bn__"